import React, {useState} from 'react';
import Post from './Post';
import {useTranslation} from "react-i18next";
import {Button} from "@components";
import {nhanvienService} from "@app/services/nhanvienService";
import {alertService} from "@app/services/alertService";
import * as mainService from '@app/services/mainService';
import {ClipLoader} from "react-spinners";

const ActivityTab = ({isActive}) => {
    const [t] = useTranslation();
    const initialNhanvien = {
        password:'',
        passwordNew:'',
        passwordNewConfirm:''
    };
    const [nhanvien, setNhanvien] = useState({...initialNhanvien});
    const [loading, setLoading] = useState(false);

    const onChangeInputReset = (e) => {
        const {name, value} = e.target;
        console.log(name +' - '+ value);
        setNhanvien((prevState) => ({
            ...prevState,
            [name]: value
        }));

    };

    const resetClick = () => {

        console.log('voclick');
        console.log(nhanvien.password);
        console.log(nhanvien.passwordNew);
        console.log(nhanvien.passwordNewConfirm);
        if(!nhanvien.password || nhanvien.password.length <=0)
        {
            alertService.error('Vui lòng nhập mật khẩu hiện tại!');
            return;
        }
        if(!nhanvien.passwordNew || nhanvien.passwordNew.length <=0)
        {
            alertService.error('Vui lòng nhập mật khẩu mới!');
            return;
        }
        if(!nhanvien.passwordNewConfirm || nhanvien.passwordNewConfirm.length <=0)
        {
            alertService.error('Vui lòng xác nhận lại mật khẩu mới!');
            return;
        }
        if(nhanvien.passwordNew != nhanvien.passwordNewConfirm)
        {
            alertService.error('Mật khẩu xác nhận mới không chính xác!');
            return;
        }
        let data = {
            password:nhanvien.password,
            passwordNew:nhanvien.passwordNew
        };
        resetPass(data);

    };
    // eslint-disable-next-line no-unused-vars
    async function resetPass(data) {
        setLoading(true);
        //delete data.ma;
        const result = await mainService.resetPassword(data);
        if (result.data.flag) {
            alertService.success(result.data.msg);
        } else {
            alertService.error(result.data.msg);
        }
        setLoading(false);
    }

    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }
    return (
        <div className={`tab-pane ${isActive ? 'active' : ''}`}>
            <form className="form-horizontal">
                <div className="form-group row">
                    <label
                        htmlFor="ten"
                        className="col-sm-2 col-form-label"
                    >
                        {t('recover.oldPassword')}
                    </label>
                    <div className="col-sm-10">
                        <input
                            type="password"
                            className="form-control"
                            id="password"
                            name="password"
                            placeholder= {t('recover.oldPassword')}
                            /*value={nhanvien.ten}*/
                            onChange={onChangeInputReset}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label
                        htmlFor="ten"
                        className="col-sm-2 col-form-label"
                    >
                        {t('recover.newPassword')}
                    </label>
                    <div className="col-sm-10">
                        <input
                            type="password"
                            className="form-control"
                            id="passwordNew"
                            name="passwordNew"
                            placeholder= {t('recover.newPassword')}
                            /*value={nhanvien.ten}*/
                            onChange={onChangeInputReset}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label
                        htmlFor="ten"
                        className="col-sm-2 col-form-label"
                    >
                        {t('recover.confirmPassword')}
                    </label>
                    <div className="col-sm-10">
                        <input
                            type="password"
                            className="form-control"
                            id="passwordNewConfirm"
                            name="passwordNewConfirm"
                            placeholder= {t('recover.confirmPassword')}
                            onChange={onChangeInputReset}
                            /*value={nhanvien.ten}*/
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <div className="offset-sm-2 col-sm-10">
                        <Button onClick={resetClick} type="button" theme="primary" icon="save">
                            {t('action.label.save')}
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default ActivityTab;
